<template>
  <v-dialog
    v-model="addNoteDialog"
    max-width="600"
    persistent
    content-class="customize-dialog"
  >
    <v-card class="pa-4">
      <v-card-title class="text-h6 font-weight-600">
        <span class="secondary--font text-capitalize">
          Add a Sticky Note
        </span>
        <span class="font-weight-regular subtitle-1">
          Note: Sticky notes are only for internal reference.
        </span>
      </v-card-title>

      <v-card-text class="body-2 px-4 mt-5">
        <v-form ref="addNoteForm" class="mt-1">
          <v-text-field
            label="Title"
            required
            outlined
            class="required"
            v-model="noteTitle"
            :rules="[(v) => !!v || 'Title is required', v => /^[a-zA-Z0-9_ ]*$/gm.test(v) || 'Invalid title']"
          ></v-text-field>

          <v-textarea
            v-model="noteDescription"
            label="Description"
            required
            outlined
            class="required"
            rows="3"
            row-height="25"
            :rules="[(v) => !!v || 'Description is required']"
          ></v-textarea>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          text
          @click="closeDialog"
          class="font-weight-bold"
          v-track="'cancel-sticky-note-dialog'"
        >
          Cancel
        </v-btn>
        <v-btn
          :disabled="noteTitle === '' || noteDescription === ''"
          class="font-weight-bold"
          v-track="'add-sticky-note'"
          :dark="noteTitle !== '' && noteDescription !== ''"
          :loading="saveLoader"
          @click="saveNote"
        >
          Add
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  export default {
    name: 'add-note-dialog',
    props: ['addNoteDialog', 'saveLoader'],
    data() {
      return {
        noteTitle: '',
        noteDescription: '',
      }
    },
    methods: {
      /**
       * Function to reset form.
       */
      reset () {
        if(this.$refs.addNoteForm)
          this.$refs.addNoteForm.reset()
      },
      /**
       * Function to reset validation.
       */
      resetValidation(){
        if(this.$refs.addNoteForm)
          this.$refs.addNoteForm.resetValidation()
      },
      /**
       * Function to close delete view dialog.
       */
      closeDialog(){
        this.$emit("toggleAddNoteDialog")
      },
      /**
       * Function to delete saved view here.
       */
      async saveNote(){
        const valid = await this.$refs.addNoteForm.validate()
        if(!valid) { return }
        this.$emit("onSaveNote", this.noteTitle, this.noteDescription);
      },
    }
  }
</script>